import { AccountProperty } from '@/types/userProperty.interface';

export const getFormattedPropertyAddress = (property: AccountProperty | undefined) => {
  if (!property || !property.address1 || !property.city || !property.state || !property.zipCode) {
    return <>No address info</>;
  }
  return (
    <>
      {property?.address1}
      {','}
      <br />
      {property?.city + ', ' + property?.state + ' ' + property?.zipCode}
    </>
  );
};
